/**
 *  @class
 *  @function RecentlyViewedProducts
 */

function moveSliderButtons() {
  if (document.querySelector('.section-recently-viewed-products--custom .carousel__slide:first-child .product-featured-image')) {
    var slide_thumb_height = document.querySelector('.section-recently-viewed-products--custom .carousel__slide:first-child .product-featured-image').offsetHeight;
    document.querySelectorAll('.section-recently-viewed-products--custom .flickity-button').forEach((btn)=>{
      var btn_height = btn.offsetHeight;
      btn.style.top = Number((slide_thumb_height / 2) - (btn_height / 2)) + "px";
    });
  }
}

if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=recently-viewed-custom&type=product&columns_class=test&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = this.getAttribute('data-max-products');
      this.products = '';
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof (recentIds) !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }
    connectedCallback() {
      this.buildUrl();
    }
    buildUrl() {
      let i = 0;
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += 'handle:' + val + ' OR ';
        i++;
      });

      this.url = this.url + encodeURIComponent(this.products);

      this.fetchProducts();
    }
    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            recommendations.querySelectorAll('[data-availability-status="sold_out"]').forEach(el => el.closest('li').remove());
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add('product-recommendations--loaded');
          }
        })
        .then(text => {
          var slide_css_class = this.getAttribute('data-columns-class');
          if (this.querySelector('.carousel__slide')) {
            this.querySelectorAll('.carousel__slide').forEach((slide) => {
              slide.setAttribute('class',slide_css_class);
            });
          }
          var elem = document.querySelector('.section-recently-viewed-products--custom .carousel');
          var flkty = new Flickity( elem, {
            contain: true,
            cellAlign: 'left',
            groupCells: true,
            prevNextButtons: true
          });
          moveSliderButtons();
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
window.addEventListener('resize',moveSliderButtons);